import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '~/components';
import { cn } from '~/style';

export const FormSelect = ({
  value,
  items,
  onChange,
  label,
  placeholder,
  className,
  allowEmpty = false,
}: {
  value: string;
  items: { id: string; name: string }[];
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  className?: string;
  allowEmpty?: boolean;
}) => {
  return (
    <div className={cn('space-y-4', className)}>
      {label && <div>{label}</div>}

      <Select
        onValueChange={(value) => {
          onChange(value === '--' ? '' : value);
        }}
        value={value}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder={placeholder || 'Select one'} />
        </SelectTrigger>

        <SelectContent>
          <SelectGroup>
            {allowEmpty && <SelectItem value="--">None</SelectItem>}

            {items.map((item) => (
              <SelectItem value={item.id} key={item.id}>
                {item.name}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};
